import styled from "@emotion/styled";
import {
    mediaQuery,
    breakpoints,
    gutterSizes,
    colorVariables,
} from "@gumtree/ui-library/src/base/theme";
import { Tabs } from "@gumtree/ui-library";
import { newLayout } from "../../app.style";

export const MapTabContainer = styled.div<{ isMobileCardsLayout: boolean }>`
    width: 100%;

    & .directions-container {
        text-align: center;
        padding: ${gutterSizes.large};
    }

    ${({ isMobileCardsLayout }) => isMobileCardsLayout && newLayout}
`;

export const StyledTabs = styled(Tabs)`
    border: solid 1px ${colorVariables.borderLight};

    ${mediaQuery.from(breakpoints.medium)} {
        margin-bottom: ${gutterSizes.xxlarge};
    }
`;

export const ImageCarouselNoTabs = styled.div`
    border: solid 1px ${colorVariables.borderLight};
`;

export const MapNoTabs = styled.div`
    padding: ${gutterSizes.medium};
    box-sizing: border-box;
    border: solid 1px ${colorVariables.borderLight};
    margin: 0 6px ${gutterSizes.xlarge} 0;
`;
